import { InjectableClass } from '@fino/lib-injection';
import _ from 'lodash';

export class ReceivingService extends InjectableClass {
  constructor(ticketsService, appConfig, ReceivingStates, ReceivingDataModifiers) {
    'ngInject';
    super({ ticketsService, appConfig, ReceivingStates, ReceivingDataModifiers });
  }

  get states() {
    const requestConfig = this.appConfig.ui.receivingRequest;
    return _.filter(this.ReceivingStates, (state, name) => {
      return !!requestConfig[name];
    });
  }

  get dataModifiers() {
    return this.ReceivingDataModifiers;
  }

  getStateName(index) {
    return this.ticketsService.getStateName(index, this.states);
  }

  getStateIndex(state) {
    return this.ticketsService.getStateIndex(state, this.states);
  }

  nextState(state, defaultState = null) {
    return this.ticketsService.nextState(state, this.states, defaultState);
  }

  prevState(state, defaultState = null) {
    return this.ticketsService.prevState(state, this.states, defaultState);
  }
}
